import {
  Component,
  OnInit,
  AfterViewInit,
  OnDestroy,
  ViewChild,
  ElementRef,
  HostListener,
  ChangeDetectorRef,
} from "@angular/core";
import { Subscription } from "rxjs";
import { OverlayPanel } from "@bfx/primeng/overlaypanel";

import { BfxApplicationNotificationService } from "./services/bfx-application-notification.service";
import { NativeDesktopSupport } from "../bfx-native-desktop/native-desktop-support";

import { ConnectionStatus, ConnectionStatusPromiseService } from "shared/broker-client-services";

import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

const FILLED_NOTIFICATION_CLASS = "icon-notification_filled";
const EMPTY_NOTIFICATION_CLASS = "icon-notification";

@Component({
  selector: "bfx-notifications-bar",
  templateUrl: "./html/bfx-notifications-bar.html",
  standalone: false,
})
export class BfxNotificationsBarComponent implements AfterViewInit, OnInit, OnDestroy {
  private notificationsCounterSubscription: Subscription;
  public notifyCounter: number = 0;
  public notificationCountAnimation = false;
  public notificationHover = false;
  // public connectionStatusSubscription: Subscription;
  // public connectionStatus: number = 0;

  public iconClass: string = EMPTY_NOTIFICATION_CLASS;

  @ViewChild("op") op: OverlayPanel;

  public get desktop(): boolean {
    return NativeDesktopSupport.isNativeDesktopContainer();
  }

  constructor(private _appNotificationService: BfxApplicationNotificationService) {
    // private _connectionStatusService: ConnectionStatusPromiseService,
    // this.subscribeToConnectionStatusService();
    this.subscribeToCounter();
  }

  ngOnInit() {
    // const initConnectionState = this._connectionStatusService.isConnectionActive;
  }

  ngAfterViewInit() {
    this.op.onShow.subscribe(() => {
      this._appNotificationService.paginatorReset();
    });
  }

  ngOnDestroy() {
    this.notificationsCounterSubscription.unsubscribe();
    // this.connectionStatusSubscription.unsubscribe();
  }

  notifyCounterAnimate(notifyCounter) {
    let counter = this.notifyCounter;
    if (notifyCounter > this.notifyCounter) {
      this.notificationCountAnimation = true;
      setTimeout(() => {
        this.notificationCountAnimation = false;
      }, 500);
    }
  }

  public subscribeToCounter(): void {
    this.notificationsCounterSubscription = this._appNotificationService.notifyCounter$.subscribe(
      (response) => {
        this.notifyCounterAnimate(response.notifCounter);
        this.notifyCounter = response.notifCounter;
        this.iconClass =
          this.notifyCounter > 0 ? FILLED_NOTIFICATION_CLASS : EMPTY_NOTIFICATION_CLASS;
      },
    );
  }

  // public subscribeToConnectionStatusService(): void {
  //   this.connectionStatusSubscription = this._connectionStatusService
  //     .getConnectionEvents()
  //     .subscribe((event: ConnectionStatus) => {
  //       this.processConnectionStatus(event);
  //     });
  // }
  // private processConnectionStatus(event: any) {
  //   this.connectionStatus = event.getStatus();
  // }

  // this trigger a call back function to set the paginator to first page
  public toggleOverlayPanel($event, op: any) {
    op.toggle($event);
  }
}
